import { Link } from 'expo-router'
import { useId, type ReactNode } from 'react'

/**
 * Inspired from https://stackoverflow.com/a/25821576/7900695
 *
 * Regex by @stephenHay from https://mathiasbynens.be/demo/url-regex:
 * - the shortest
 * - among the most accurate
 * - safe (checked on https://devina.io/redos-checker)
 * Extended:
 * - to include www.truc.com urls
 * - to work inline
 * - to prevent ":" to be included in the pathname
 */
const urlRegex = /((?:https?:\/\/|www.)[^\s/$.?#].[^\s:]*[^\s.,:;])/

export const LinkifyText = ({ text }: { text: string }): ReactNode => {
  const parts = text.split(urlRegex) // Split text around urls
  const cId = useId()
  return parts.map((part, index) =>
    urlRegex.test(part) ? (
      // oxlint-disable-next-line react/no-array-index-key
      <Link key={`${index}-${cId}`} href={part} className="underline color-content-link">
        {part}
      </Link>
    ) : (
      part
    ),
  )
}
